<template>
  <section
    v-if="toSign.length"
    class="client-cabinet-action-panel"
    aria-labelledby="client-page-action-title"
    data-testid="client-page-action-required"
  >
    <div>
      <h2 id="client-page-action-title">{{ $t("client_page.cabinet.action_required.title") }}</h2>
      <p>{{ $t("client_page.cabinet.action_required.sign_document_hint", { name: firstDocument.name || $t("client_page.cabinet.documents.untitled") }) }}</p>
    </div>
    <ul class="client-cabinet-action-panel__actions">
      <li v-for="(doc, index) in toSign" :key="index">
        <a :href="doc.signLink" target="_blank" rel="noopener" class="client-cabinet-primary-link">
          {{ $t("client_page.cabinet.documents.sign") }}
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
// FT-200 STEP-05 (REQ-08): «Требует действия» — только если есть: документ ждёт подписи клиента.
// Что ждёт подписи — signLink (DocuSeal: ссылка клиента до завершения; OkiDoki: ссылка подписания до подписи).
import { signLink } from "@/utils/clientCabinetView";

export default {
  name: "ActionRequired",
  props: {
    documents: { type: Array, default: () => [] },
  },
  computed: {
    toSign() {
      return (this.documents || [])
        .map((doc) => ({ name: doc.name, signLink: signLink(doc) }))
        .filter((doc) => doc.signLink);
    },
    firstDocument() {
      return this.toSign[0] || {};
    },
  },
};
</script>
